import React, { FC, ReactNode } from 'react'
import { Headline } from '~m/designSystem/components/Headline'
import styles from './ContentMainHeader.module.css'

interface ContentMainHeaderProps {
  heading: ReactNode
}

export const ContentMainHeader: FC<
  React.PropsWithChildren<ContentMainHeaderProps>
> = ({ heading, children, ...props }) => {
  return (
    <div className={styles.ContentMainHeader} {...props}>
      <Headline className={styles.ContentMainHeader__headline}>
        {heading}
      </Headline>
      {children}
    </div>
  )
}
